module.exports = __webpack_public_path__ + "static/img/lres7.6738d35.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/lres7.png
// module id = JhX1
// module chunks = 1